import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-success-dialog',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.scss'],
    standalone: false
})
export class SuccessDialogComponent implements OnInit {

  attachmentId: string;
  verifyId: string;
  afId: string;
  skinnyForm: string;
  thankYouMessage: string = 'Thank you for submitting your registration and consent. You will receive an email in the next few hours with next steps in the process to schedule an appointment if needed.'

  constructor(private userService: AuthService, public dialogRef: MatDialogRef<SuccessDialogComponent>) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.verifyId = this.userService.getVerifyId();
    this.afId = this.userService.getAfId();
    this.skinnyForm = localStorage.getItem('skinnyForm');

    if (this.skinnyForm === '1') {
      this.thankYouMessage = 'Thank you for completing your registration and providing your consent. You will be contacted by our approved vendor regarding the next step in the process.';
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  generatePDF(): void {
    let fileName = "Applicant Form_" + this.afId;
    this.userService.generatePDF(this.afId, this.verifyId, fileName).subscribe();
  }
}
